import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth42: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38,354.7c26.4-17.6,48.8-3.9,48.8-3.9l1,4.8,7.4,37.4,4.6,30.6,1.9,16.4.9,19.4-.8,3.6-1.9,3.5-2.8,1.9-3.3,1.7-4.9-.2h-5.7s-3.9.9-3.9.9l-4.1.5-4.6,1.6-11.2.5-3.2-.2-8.5-1.4s-1.5-.4-2-.5-4.4.2-4.4.2l-6.1-.6-5.8-1.3-4.1-2.2-1.9-3.6,2.5-32.4,4.9-35.8,5.5-29.2,1.7-11.7h0Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M86.8,350.9l-.7-4.7c-22.8-13.4-47.1,3-47.1,3l-1,5.5c25.4-17.1,48.8-3.9,48.8-3.9h0Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M70.4,378.1a8.2,8.2 0 1,1 -16.4,0a8.2,8.2 0 1,1 16.4,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M97.6,418.8l-6.3-43.8c-44.8,27.8,6.3,43.8,6.3,43.8Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.7,417.6l7.5-42.5c45.1,28.2-7.5,42.5-7.5,42.5Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M87.9,355.7c-27.5,22.5-17.7,116.8-17.7,116.8l7.8-1,7.8-1.3,3.8-.2,3.7-.7,4.5-1.5,2.5-2.3,1.5-3v-14.2s-4.2-29.5-4.2-29.5l-6.3-43.8-3.6-19.4h.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M37.6,357c24,15.8,17.7,116,17.7,116l-15.2-.8-10.5-.8-5-3-2.3-4.2.5-17.9,3.9-28.7,7.5-42.5,3.4-18.2h0Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38,354.7c26.4-17.6,48.8-3.9,48.8-3.9l1,4.8,7.4,37.4,4.6,30.6,1.9,16.4.9,19.4-.8,3.6-1.9,3.5-2.8,1.9-3.3,1.7-4.9-.2h-5.7s-3.9.9-3.9.9l-4.1.5-4.6,1.6-11.2.5-3.2-.2-8.5-1.4s-1.5-.4-2-.5-4.4.2-4.4.2l-6.1-.6-5.8-1.3-4.1-2.2-1.9-3.6,2.5-32.4,4.9-35.8,5.5-29.2,1.7-11.7h0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M22.4,448.3c-1-1,79.3-.1,79.3-.1l.7,14.4-4.1,5.5-8.5,2.8h-8.7s-18.9,3.7-18.9,3.7l-15.9-2.5-12.9-.5-8.7-3.2-2.6-5.1.3-15h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'25.4 426.2 33 414.7 36.7 430.7 41.8 411.2 48.3 431.3 54.2 411.2 61.1 431 67.3 411.2 74.1 432.2 79.5 412.3 86.8 432.2 89.1 415.5 98.3 425.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'58.7 353 63.7 348 57.8 342 63 336.8 57.5 331.4 62.4 326.4 57.5 321.5 62.3 316.8 56.7 311.1 61.3 306.5 56.8 302 61.4 297.4 56.5 292.5 61.4 287.6 56.8 283 61.7 278.1 57.4 273.8 62.2 268.9 57 263.7 62.6 258 57.5 253 63.1 247.5 57.9 242.2 63.3 236.8 57.4 230.8 62.4 225.8 56.9 220.2 62.8 214.3 57.6 209.1 63 203.7 57.5 198.1 63.2 192.4 57.7 187 63 181.7 57.3 176 62.7 170.6 57.1 165 62.3 159.7 56.6 147.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'44.2 256.6 46.3 251.7 48.7 256.9 51.3 252.2 54.4 256.5 58.1 251.5 61.4 257.5 65.4 251.7 69.4 257.5 72.7 252.2 76.1 257.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '90.7 92.7 96.1 92.9 100.4 95.8 102.4 99.7 102.5 105.1 101 108.7 99 113.6 96.2 117.6 92.8 122.9 87.7 130 82.5 135.9 77.1 139.8 66.4 142.9 50.7 142.4 45 140.5 40.6 137.5 36.8 134 25.1 119.9 20.2 114.8 16 109.4 14.6 103.2 14.8 99.5 17.8 95.5 22.7 92.9 28.8 91.8 41.1 73 48.8 65.5 51.1 63.7 59.8 62 67.3 64.3 75.8 72.5 88.6 91.3 90.7 92.7',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M43.1,126.5h34.7c-18.2,20.3-34.7,0-34.7,0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M95.4,118.2l4.9-6.2s2.4-5.9,2.3-5.9v-6.2s-1.3-2.5-1.3-2.5l-4.2-3.9-6.5-1c-34.5,11.7,4.8,25.7,4.8,25.7Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.1,91.8c30.9,12.8-8.8,24.1-8.8,24.1l-2.3-2.6-4.3-7.2-.3-5.2,2.6-4.3,5.5-3.5,7.7-1.3h0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '29.2 91.8 21.5 93.1 16 96.6 13.4 100.9 13.7 106.1 18 113.5 22.4 118 95.3 118.2 100.2 112 102.7 106.1 102.6 99.9 101.3 97.4 97.1 93.5 89.7 92 29.2 91.8',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M102.5,105.1l-1.5,3.6-2,4.9-2.8,4-3.4,5.3-5.1,7.1-5.2,5.9-5.4,3.9-10.7,3.1-15.7-.5-5.7-1.9-8.2-6.5-11.7-14.1-4.9-5.1-4.2-5.4-1.4-6.2c36,19.5,87.9,1.9,87.9,1.9Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M14.6,103.2l.2-3.7,3-4,4.9-2.6,6.1-1.1,12.3-18.8,7.7-7.5,2.3-1.8,8.7-1.7,7.5,2.3,8.5,8.2,12.8,18.8,2.1,1.4,5.4.2,4.3,2.9s2,3.9,2.1,3.9v5.4c-59,17.5-87.9-1.9-87.9-1.9Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'18.2 101 26.6 113.9 30.8 96 36.4 117.9 43.7 95.4 50.4 117.9 58 95.7 65 117.9 72.6 94.3 78.8 116.7 86.9 94.3 89.4 113.1 99.8 101.6',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M86.1,174.5s-21.2,23.9-52.1.2l-1.1-8.7-1-8.9-5.6-18.5-2.5-13.3-1.8-11.2-3.2-18.7-1.8-16.5-1.9-11-.4-20,1.6-4.1,7.3-5.6,6.7-1.1,14.3-.6,19.6-1.2,21.4,5.4,10,.8,5.4,4,.6,4.3.4,19.7-5,43.8-10.9,61.3h0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M85.3,182.4c-26.3,19.7-50.6,0-50.6,0l-.7-7.6c30.8,23.7,52.1-.2,52.1-.2,0,0-.8,7.8-.8,7.8Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M95.9,119.2l6.1-51.5c-56.7,7.2-6.1,51.5-6.1,51.5Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M22.6,117.2l-7.1-49.5c53.4,8.6,7.1,49.5,7.1,49.5Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.9,118.3h48.4c-26,119.5-48.4,0-48.4,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '102.1 61.8 14.4 61.8 14.5 46.6 22.3 38.9 28.4 37.2 38.3 37.6 54.7 35.2 64.7 35.4 85.1 40.1 93.4 41.1 102.3 47 102.1 61.8',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M86.7,170.5c-24.9-48.3-19.7-134-19.7-134l17.1,3.6,9.2.4,7.6,5,1.4,24.1-3.6,27.7-4,30.5-8,42.7h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M51.1,36c3.4,55-17.7,130.8-17.7,130.8l-.2-2.2-1.8-8.2-7.4-29.7-6.6-42.3-3-29.7,1.2-8.8,6.6-6.8,7-1.8,7.8.6,14-1.8h.1Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M86.1,174.5s-21.2,23.9-52.1.2l-1.1-8.7-1-8.9-5.6-18.5-2.5-13.3-1.8-11.2-3.2-18.7-1.8-16.5-1.9-11-.4-20,1.6-4.1,7.3-5.6,6.7-1.1,14.3-.6,19.6-1.2,21.4,5.4,10,.8,5.4,4,.6,4.3.4,19.7-5,43.8-10.9,61.3h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'19.9 93 28.1 107.5 32.2 87.2 37.6 111.9 44.6 86.7 51.2 111.9 58.5 87 65.4 111.9 72.7 85.4 78.7 110.7 86.6 85.4 89.1 106.6 99.2 93.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'54.1 185.6 59.6 191.1 54.6 196 59.5 200.9 54.7 205.7 60.2 211.3 55.6 215.9 60 220.4 55.3 225 60.2 230 55.2 234.8 59.8 239.5 54.8 244.3 59.1 248.7 54.2 253.5 59.4 258.8 53.7 264.4 58.7 269.5 53.1 275 58.3 280.2 52.8 285.6 58.7 291.7 53.6 296.6 59 302.2 53 308.1 58.2 313.4 52.7 318.7 58.2 324.3 52.5 330 57.9 335.5 52.5 340.7 58.1 346.5 52.7 351.8 58.3 357.5 52.9 362.7 58.6 374.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'40.8 266.7 43.1 272.2 45.8 266.5 48.7 271.7 52.1 266.9 56.2 272.5 59.9 265.8 64.4 272.2 68.8 265.8 72.5 271.7 75.3 266',
			],
		},
	},
};
